import React, { useMemo } from 'react';
import { IProductVariant, ISize } from 'utils/types/contentful';
import { IProduct } from '../../../../../utils/types/contentful';
import { Image } from '../../../Media/Image/index';
import clsx from 'clsx';
import { useMediaQuery } from 'utils/hooks/useMediaQuery';
import './index.css';
import HoverCarousel from 'components/UI/Cards/Shop/VariantImage/HoverCarousel';

interface IShopItemVariantImagesProps {
  product: IProduct;
  variants: IProductVariant[];
  selectedSize: ISize;
  selectedVariant: IProductVariant;
}

export const ShopItemVariantImages: React.FC<IShopItemVariantImagesProps> = ({
  product,
  variants,
  selectedSize,
  selectedVariant,
}) => {
  const shuffledLifeStyledImage = useMemo(() => {
    return product.lifestyleImages?.sort((a, b) => 0.5 - Math.random());
  }, [product]);

  const returnVariantImage = (image, variantImages, vObj) => {
    const variantLifeStyles = [...(vObj?.lifestyleImages || [])]?.sort(
      () => 0.5 - Math.random()
    );
    const activeLifeStyles = shuffledLifeStyledImage || variantLifeStyles;

    const defaultVariant =
      (variantImages && variantImages?.[0]) ||
      (product.posterImages && product.posterImages?.[0]);
    const hoverImages = [
      ...(product.posterImages || []),
      ...(variantImages?.slice(1) || []),
      ...(activeLifeStyles || []),
    ];

    return (
      <div
        className={`relative pointer-events-none w-full h-full bg-white flex items-center overflow-hidden`}
      >
        {defaultVariant && (
          <div className='flex w-full overflow-hidden bg-white justify-center '>
            <Image
              width='100%'
              objectFit='cover'
              bgColor='white'
              placeholder='blurred'
              media={defaultVariant.media}
            />
          </div>
        )}

        <HoverCarousel
          mobileImage={activeLifeStyles?.[0]?.media}
          desktopImages={hoverImages}
        />
      </div>
    );
  };

  // return image for product pack
  if (product?.posterImage) {
    return returnVariantImage(product?.posterImage);
  }

  // return default product variant images
  return variants?.map((variant, i) => {
    let defaultDisplay = false;

    if (selectedSize) {
      defaultDisplay =
        selectedVariant.color?.shopifyKey?.toLowerCase() ===
          variant?.color?.shopifyKey?.toLowerCase() &&
        selectedSize.value === variant?.size?.value;
    } else {
      defaultDisplay =
        !selectedVariant ||
        selectedVariant.color?.shopifyKey?.toLowerCase() ===
          variant?.color?.shopifyKey?.toLowerCase();
    }

    const defaultVariantImage = variant?.images?.[0];

    if (defaultDisplay) {
      return (
        <React.Fragment key={variant.title}>
          {returnVariantImage(
            defaultVariantImage,
            variant?.posterImages,
            variant
          )}
        </React.Fragment>
      );
    }
    return <></>;
  });
};
